import { getSearchParams } from '@shakkerai/utils';
import { isMainland } from '../constants';

export function getProjectId() {
  if (isMainland) {
    return getSearchParams('projectId') ?? '';
  }
  // 海外不区分项目, 先写死project1
  return 'project1';
}
